import React, { useEffect, useRef, useState } from "react";
import Buttons from "../../../../../components/ui/button/Buttons";
import { verifiedCompetencyConfig } from "./VerifiedCompetency.data";
import { useLazyGetCompetencyDetailsByMemberIdQuery, useSetCompentancyVisibleByMemberIdMutation, } from "../../../../../app/services/GMAP/verifiedCompetency";
import { useParams } from "react-router-dom";
import { decryptAESID } from "../../../../../utils/Encryption";
import FinalMolGrid from "../../../../../components/FinalMolGrid/FinalMolGrid";
import ToastService from "../../../../../services/toastService/ToastService";
import { getAuthProps } from "../../../../../lib/authenticationLibrary";

const VerifiedCompetency = () => {
    const molGridRef = useRef();
    const { id } = useParams();
    const gmapMemberId = id ? decryptAESID(id, false) : 0;
     const authData = getAuthProps();
    const [dataSource, setDataSource] = useState([]);
    const [updatedRows, setUpdatedRows] = useState([]);
    const [SetCompentancyVisibleByMember, { isSuccess: isSuccessMember, isLoading: isLoadingMember, data: memberResponse },] = useSetCompentancyVisibleByMemberIdMutation();
    const [competencyDetailsByMember, { isSuccess, isLoading, data: compentancyVisibleByMemberResponse },] = useLazyGetCompetencyDetailsByMemberIdQuery();

    useEffect(() => {
        if (isSuccess && compentancyVisibleByMemberResponse) {
            setDataSource(compentancyVisibleByMemberResponse);
        }
    }, [isLoading, isSuccess, compentancyVisibleByMemberResponse]);

    useEffect(() => {
        if (isSuccessMember && memberResponse) {
            competencyDetailsByMember(gmapMemberId);
            ToastService.success("Data Updated");
        }
    }, [isSuccessMember, isLoadingMember, memberResponse]);

    useEffect(() => {
        if (id) {
            competencyDetailsByMember(gmapMemberId);
        }
    }, [id]);

    const handleRowSelection = (selectedRow) => {
        // Find the original row in datasource
        const originalRow = dataSource.find((row) => row.cometencyId === selectedRow.cometencyId);
        if (!originalRow) return;

        const newDisplayValue = originalRow.isDisplay ? false : true;

        // Track updated row with new display value
        setUpdatedRows((prev) => {
            const existing = prev.filter((row) => row.GmapVerifiedCompetencyId !== selectedRow.cometencyId);
            return [
                ...existing,
                {
                    GmapVerifiedCompetencyId: selectedRow.cometencyId,
                    IsDisplay: newDisplayValue,
                    GmapMemberId: gmapMemberId,
                    UpdatedBy : 115,
                    UpdatedAppId : authData?.adminUserId
                },
            ];
        });
    };

    const handleSave = () => {
        if (updatedRows.length === 0) return;

        const req = {
            IsDisplayList: updatedRows,
        };
        SetCompentancyVisibleByMember(req);
    };

    return (
        <>
            <FinalMolGrid
                ref={molGridRef}
                configuration={verifiedCompetencyConfig}
                dataSource={dataSource}
                allowPagination={false}
                isLoading={isLoading || isLoadingMember}
                onHandleRowSelect={handleRowSelection}
            />
            <div className="col-md-12 mb-2 d-flex justify-content-end">
                <Buttons
                    buttonText={"Save"}
                    isLoading={isLoadingMember}
                    buttonTypeClassName="btn success-btn"
                    onClick={handleSave}
                />
            </div>
        </>
    );
};

export default VerifiedCompetency;
